import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import CheckBox from 'src/component/CheckBox'

const Title = ({ handleActive, value, item, children, isReplaced, toggleOpenAlt, handleDonatedStock, donatedStockValue }: any) => {

    const { t } = useTranslation()

    const totalPrice = useMemo(() => (item?.price * item?.amount)?.toFixed(2), [item?.price, item?.amount])

    const handleOpenAltTab = () => {
        handleActive(false)
        toggleOpenAlt((prev: boolean) => !prev)
    }

    const handleCheck = (value: boolean) => {
        handleActive(value)
        if (value) toggleOpenAlt(false)
    }

    return (
        <div className={`accordion-header ${isReplaced ? "need-to-change" : ""}`} id="headingOne">
            <h2 className="mb-0">
                {isReplaced ?
                    <span className='alt-div d-block need-to-change' >
                        {t("needt-to-change")}
                    </span> : ""}

                <button className={`flex-row btn btn-link ${handleDonatedStock && "justify-content-between"} btn-block text-right row mb-3`} type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">


                    <div className={`flexed-row col-sm-5 ${handleDonatedStock && "col-md-3"}`}>
                        <CheckBox value={value} setValue={(value: boolean) => handleCheck(value)} />
                        <div className='flex-row'>{item?.medicineName}</div>
                    </div>


                    <div className={`flexed-row col-sm-5 text-center ${handleDonatedStock && "col-md-3"}`}>
                        <div className='amount-type'>
                            <span>{t("units-amount")}</span> {item?.amount}
                        </div>
                        <div className='amount-cost'>
                            <span>{t("units-cost")}</span> {totalPrice}
                        </div>
                    </div>
                    {handleDonatedStock &&
                        <div className='d-flex align-items-center justify-content-center gap-2 col-sm-5 col-md-3'>
                            <CheckBox value={donatedStockValue} setValue={(value: boolean) => handleDonatedStock(value)} />
                            <p className='m-0 text-center'>{t("fromDonatedStock")}</p>
                        </div>
                    }
                </button>


                {children}
                <div className='alt-div flex-row amount-cost' onClick={handleOpenAltTab}>

                    {t("select-alternate")}
                </div>



            </h2>
        </div>
    )
}

export default Title